import React, { useEffect, useState, useRef } from 'react';
import {
  Button,
  Dialog,
  Input,
  Form,
  Select,
  Checkbox,
  DatePicker,
  Message,
  Card,
  Table,
  Switch,
  Pagination,
  CascaderSelect,
} from '@alifd/next';
import client from '@/lib/feathers';
import Swal from 'sweetalert2';
import moment from 'moment';
import axios from 'axios';
import ReactDragListView from 'react-drag-listview'; // 拖曳功能
import { Modal, Image } from 'antd'; // dialog UI
import { pdfjs, Page } from 'react-pdf';
import ezconImg from '../../../public/ezcon.png';
import styles from './index.module.scss';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
const Option = Select.Option;
const { Item } = Form;
const { RangePicker } = DatePicker;

const DeviceList = (props) => {
  const Document = React.lazy(() => {
    return import('react-pdf').then((module) => ({ default: module.Document }));
  });
  const FileViewer = React.lazy(() => {
    return import('react-file-viewer');
  });
  // menuCoVendor 廠商
  const menuCoVendor = client.service('menuCoVendor');
  // communityDevice 設備Table
  const communityDevice = client.service('communityDevice');

  const [deviceArr, setDeviceArr] = useState([]);
  const [vendorArr, setVendorArr] = useState([]);
  const [addDeviceDialog, setAddDeviceDialog] = useState(false);
  const [editDeviceDialog, setEditDeviceDialog] = useState(false);
  const [editCategoryDialog, setEditCategoryDialog] = useState(false);
  const [serachDialog, setSerachDialog] = useState(false);
  const [editDeviceIndex, setDeviceIndex] = useState('');
  const [editCategoryIndex, setEditCategoryIndex] = useState('');
  const [deviceName, setDeviceName] = useState('');
  const [categoryName, setCategoryName] = useState('');
  const [addCategory, setAddCategory] = useState('');
  const [rule, setRule] = useState('');
  const [ruleType, setRuleType] = useState('');
  const [ruleId, setRuleId] = useState('');
  const [todo, setTodo] = useState([]);

  const [editingObj, setEditingObj] = useState({});
  // console.log("editingObj", editingObj)
  // console.log("todo", todo)

  // preview
  const [previewSingleDialog, setPreviewSingleDialog] = useState(false);
  const [ruleFiles, setRuleFiles] = useState([]);
  const [fileType, setFileType] = useState('');
  const [fileViewerType, setFileViewerType] = useState('');
  const [fileViewerPath, setFileViewerPath] = useState('');
  const [fileViewerKey, setFileViewerKey] = useState('');
  const [fileViewerDialog, setFileViewerDialog] = useState(false);
  const [fileViewerStatus, setFileViewerStatus] = useState(false);
  const [numPages, setNumPages] = useState(null);

  // 搜尋
  const [serachCategory, setSerachCategory] = useState('');
  const [serachKey, setSerachKey] = useState('');

  // sort
  const [curdataIndex, setcurDataIndex] = useState('createdTime');
  const [curorder, setcurOrder] = useState('asc');

  // 換頁
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = deviceArr.slice(indexOfFirstPost, indexOfLastPost);

  // communityRules 社區規範
  const communityRules = client.service('communityRules');
  const [communityRulesArr, setCommunityRulesArr] = useState([]);

  //  檔案Table
  const communityFiles = client.service('communityFiles');
  const [communityFilesArr, setCommunityFilesArr] = useState([]);
  const [files, setFiles] = useState('');
  const [filesType, setFilesType] = useState('');
  const [document, setDocument] = useState([]);
  // console.log('document', document)

  // Vendor
  const [deviceVendor, setDeviceVendor] = useState([]);
  const [vendorName, setVendorName] = useState('');

  const currentDate = moment();
  const currentDate1 = moment().subtract(1, 'days');

  const disabledDate = (date, view) => {
    switch (view) {
      case 'date':
        return date.valueOf() <= currentDate1.valueOf();
      case 'year':
        return date.year() < currentDate.year();
      case 'month':
        return (
          date.year() * 100 + date.month() <
          currentDate.year() * 100 + currentDate.month()
        );
      default:
        return false;
    }
  };

  // residentAccountNumbers
  async function funFindRules(para) {
    const result = await communityRules.find({ query: para });
    return result && result.data ? result.data : [];
  }

  function rulesSort(a, b) {
    return a.type > b.type ? 1 : -1 && a.title > b.title ? 1 : -1;
  }

  function serverRulesDataUpdate() {
    funFindRules({}).then((result) => {
      setCommunityRulesArr(result.sort(rulesSort));
    });
  }
  useEffect(() => {
    serverRulesDataUpdate();
  }, []);

  // funFindFiles
  async function funFindFiles(para) {
    const result = await communityFiles.find({ query: para });
    return result && result.data ? result.data : [];
  }

  function serverFilesDataUpdate() {
    funFindFiles({}).then((result) => {
      setCommunityFilesArr(result);
    });
  }
  useEffect(() => {
    serverFilesDataUpdate();
  }, []);

  // communityDevice
  async function funFind(para) {
    const result = await communityDevice.find({ query: para });
    // console.log(result);
    return result && result.data ? result.data : [];
  }

  async function funCreate(obj) {
    return await communityDevice.create(obj);
  }
  async function funUpdate(id, obj) {
    return await communityDevice.patch(id, obj);
  }
  async function funRemove(id) {
    return await communityDevice.remove(id);
  }

  const serverDataUpdate = (dataIndex, order) => {
    const rdataIndex = dataIndex || curdataIndex;
    const rorder = order || curorder;

    funFind({}).then((result) => {
      setDeviceArr(
        result.sort((a, b) => {
          const result = (typeof a[rdataIndex] === 'number'
            ? a[rdataIndex].toString()
            : a[rdataIndex]
          ).localeCompare(
            typeof b[rdataIndex] === 'number'
              ? b[rdataIndex].toString()
              : b[rdataIndex]
          );
          return rorder === 'asc' ? (result > 0 ? 1 : -1) : result > 0 ? -1 : 1;
        })
      );
    });
  };
  const onTableSort = (dataIndex, order) => {
    console.log('==dataIndex:', dataIndex, 'order:', order);
    setcurDataIndex(dataIndex);
    setcurOrder(order);
    serverDataUpdate(dataIndex, order);
  };

  useEffect(() => {
    serverDataUpdate();
  }, []);

  // menuCoVendor

  async function findVendor(para) {
    const result = await menuCoVendor.find({ query: para });
    return result && result.data ? result.data : [];
  }

  function serverVendorDataUpdate() {
    findVendor({}).then((result) => {
      setVendorArr(result);
    });
  }
  useEffect(() => {
    serverVendorDataUpdate();
  }, []);

  // 類別拖曳Function
  const onDragCategoryEnd = (fromIndex, toIndex) => {
    if (toIndex < 0) return; // Ignores if outside designated area

    const items = vendorArr[0]; // 所有類別資料
    const item = items.data.splice(fromIndex, 1)[0];
    items.data.splice(toIndex, 0, item); // 把刪除的新增到移動的位置
    // console.log(items)

    updateCategory(items._id, items)
      .then((res) => {
        console.log('==categoryMenu drag categoryName success:', res);
        serverCategoryDataUpdate();
        Message.success('拖曳成功');
      })
      .catch((error) => {
        console.log('==categoryMenu drag categoryName fail:', error);
        Message.error(`${error}`);
      });
  };

  // 過濾規範類別
  function communityRulesType() {
    const rulesType = communityRulesArr.map((x) => x.type);
    // console.log(rulesType)
    return rulesType;
  }
  // 過濾規範
  function communityRulesResult() {
    const rules = communityRulesArr
      .filter((x) => x.type === ruleType)
      .map((x) => x.title);
    // console.log(rules)
    return rules;
  }

  // 過濾檔案類別
  function communityFileType() {
    const filesType = communityFilesArr.map((x) => x.type);
    // console.log(filesType)
    return filesType;
  }
  // 過濾檔案
  function communityFilesResult() {
    const files = communityFilesArr
      .filter((x) => x.type === filesType)
      .map((x) => x.title);
    // console.log(files)
    return files;
  }

  // 過濾廠商
  function communityVendorResult() {
    const vendor = vendorArr.map((x) => x.name);
    return vendor;
  }

  // 新增規範
  function addRules() {
    if (!ruleType && !rule) {
      Message.warning('請選擇規範類別及規範');
    } else if (!ruleType) {
      Message.warning('請選擇規範類別');
    } else if (!rule) {
      Message.warning('請選擇規範');
    } else {
      let rulesOne = communityRulesArr.filter((x) => x.title === rule);
      if (rulesOne.length == 0) {
        Message.warning('資料匹配錯誤!請重新整理頁面');
        return;
      }
      rulesOne = rulesOne[0];
      const todoStatus = todo.map((x) => x.id).includes(rulesOne._id);
      if (todoStatus === true) {
        Message.error('請勿建立重複規範');
      } else {
        const newTodo = {
          id: rulesOne._id,
          ruleType,
          rule,
          files: rulesOne.files,
        };
        setTodo([...todo].concat(newTodo));
      }
    }
  }

  // 取得檔案
  function getFiles(file) {
    const filesOne = communityFilesArr.filter((x) => x.title === file);
    // console.log("filesOne",filesOne)
    if (filesOne.length === 0) {
      Message.warning('資料匹配錯誤!請重新整理頁面');
    } else {
      const newTodo = {
        id: filesOne[0]._id,
        createdTime: filesOne[0].createdTime,
        updatedTime: filesOne[0].updatedTime,
        announcer: filesOne[0].announcer,
        announcementTime: filesOne[0].announcementTime,
        type: filesOne[0].type,
        title: filesOne[0].title,
        content: filesOne[0].content,
        fileType: filesOne[0].fileType,
        files: filesOne[0].files,
      };
      // setDocument(filesOne[0])
      setDocument([newTodo]);
    }
  }

  // 取得廠商
  function getVendor(val) {
    const vendorOne = vendorArr.filter((x) => x.name === val);
    // console.log("filesOne",filesOne)
    if (vendorOne.length === 0) {
      Message.warning('資料匹配錯誤!請重新整理頁面');
    } else {
      const newTodo = {
        id: vendorOne[0]._id,
        name: val,
      };
      setDeviceVendor([newTodo]);
    }
  }

  // 刪除規範
  function deleteTodo(id) {
    const updatedTodo = [...todo].filter((todo) => todo.id !== id);
    setTodo(updatedTodo);
  }

  // uploads files
  const [parsed, setParsed] = useState([]);
  const [parsed64, setParsed64] = useState([]); // Base64
  const [file, setFile] = useState('');
  const uploadFile = useRef(null);

  function beforeUpload() {
    return new Promise(async (resolve, reject) => {
      if (uploadFile.current.files.length > 0) {
        const isLt20M =
          (await uploadFile.current.files[0].size) / 1024 / 1024 < 20;

        if (!isLt20M) {
          Message.error('Image must smaller than 20MB!');
          return reject();
        }
        resolve(isLt20M);
      } else {
        setParsed64('');
      }
    });
  }

  const handleFiles = async () => {
    try {
      await beforeUpload();
      const files = [...parsed];
      const data = await uploadFile.current.files[0];
      // console.log(data)
      files.push(data);
      setParsed(files);

      // 轉Base64 上傳檔案後呈現沒有寫到DB
      const reader = new FileReader();
      reader.onload = function () {
        const dataURL = reader.result;
        setParsed64(dataURL);
      };
      reader.readAsDataURL(data);
    } catch (err) {
      console.log(err);
    }
  };

  function createCommunityDeviceWithImgUploads() {
    // communityDevice use Uploads CREATE
    return new Promise(async (resolve, reject) => {
      try {
        const formData = new FormData();
        if (!editingObj.deviceDate)
          formData.append('deviceDate', new Date().getTime());
        Object.keys(editingObj).forEach((eKey) => {
          formData.append(eKey, editingObj[eKey]);
        });
        formData.append('createdTime', new Date().toLocaleString());
        formData.append('updatedTime', new Date().toLocaleString());
        formData.append('rule', JSON.stringify(todo)); // 規範
        formData.append('document', JSON.stringify(document)); // 文件
        if (deviceVendor && deviceVendor.length > 0) {
          formData.append('deviceVendor', JSON.stringify(deviceVendor)); // 廠商
        }

        if (uploadFile.current.files.length > 0) {
          formData.append('files', uploadFile.current.files[0]);
        }

        const Res = await axios('/uploads?type=communityDevice', {
          method: 'POST',
          headers: { authorization: window.localStorage['feathers-jwt'] },
          data: formData,
        });

        resolve(Res);
      } catch (error) {
        reject();
      }
    });
  }

  function patchCommunityDeviceWithImgUploads(data) {
    // communityDevice use Uploads PATCH
    return new Promise(async (resolve, reject) => {
      try {
        let patchUrl = `/uploads?type=communityDevice&id=${data._id}`;
        const formData = new FormData();

        if (data.hasOwnProperty('rule'))
          formData.append('rule', JSON.stringify(data.rule)); // 規範
        if (data.hasOwnProperty('document'))
          formData.append('document', JSON.stringify(data.document)); // 文件
        if (data.hasOwnProperty('deviceVendor'))
          formData.append('deviceVendor', JSON.stringify(data.deviceVendor)); // 廠商
        const passKeys = ['rule', 'files', '_id', 'document', 'deviceVendor']; // 禁止FormData Patch add Key

        Object.keys(data).forEach((eKey) => {
          if (!passKeys.includes(eKey)) formData.append(eKey, data[eKey]);
        });

        if (uploadFile.current.files.length > 0) {
          formData.append('files', uploadFile.current.files[0]);
        }
        if (!uploadFile.current.files.length) {
          patchUrl = `/uploads?type=communityDevice&id=${data._id}&img=keep`;
        }
        console.log('rdy to PP:', formData);
        const Res = await axios(patchUrl, {
          method: 'PATCH',
          headers: { authorization: window.localStorage['feathers-jwt'] },
          data: formData,
        });

        resolve(Res);
      } catch (error) {
        console.log('PP err:', error);
        reject();
      }
    });
  }

  const onError = (e) => {
    console.log(e, 'error in file-viewer');
  };
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  // function communityRulesOption() {
  //   const dataSource = [];

  //   for (let i = 0; i < communityRulesArr.length; i++) {
  //     //第一層

  //     let type = communityRulesArr[i].type;
  //     let id = communityRulesArr[i]._id;
  //     let objType = dataSource.find((item) => item.label === type);
  //     if (!objType) {
  //       objType = {
  //         id: `${id}`,
  //         value: `${type}`,
  //         label: `${type}`,
  //         children: [],
  //       };
  //       dataSource.push(objType);
  //     }
  //     // 第二層
  //     let title = communityRulesArr[i].title;
  //     let objTitle = objType.children.find((item) => item.label === title);
  //     if (!objTitle) {
  //       objTitle = {
  //         id: `${id}`,
  //         value: `${type}-${title}`,
  //         label: `${title}`,
  //       };
  //       objType.children.push(objTitle);
  //     }

  //   }
  //   // console.log(dataSource)
  //   return dataSource;
  // }

  // function editRulesOption() {

  //   const arr = [];
  //   Object.entries(rule).forEach(entry => {
  //     const [key, value] = entry;
  //     arr.push({
  //       id: `${key}`,
  //       value: `${value.type}`,
  //       label: `${value.type}`,
  //       children: [{
  //         id: `${key}`,
  //         value: `${value.type}-${value.title}`,
  //         label: `${value.title}`,
  //       }],
  //     })

  //   })
  //   console.log(arr)
  //  return arr;

  // }

  return (
    <>
      <Modal
        okText
        cancelText="關閉"
        mask={false}
        className={styles.modal}
        // width={"100vw"}
        style={{ top: 0 }}
        visible={previewSingleDialog}
        onOk={() => {
          setPreviewSingleDialog(false);
          setFileViewerPath('');
          setFileViewerType('');
        }}
        onCancel={() => {
          setPreviewSingleDialog(false);
          setFileViewerPath('');
          setFileViewerType('');
        }}
      >
        {ruleFiles.length > 1 ? (
          <div className={styles.previewFileContainer}>
            <div className={styles.previewMultipleBox}>
              {ruleFiles.map((list, index) => {
                return (
                  <div key={index} className={styles.previewBtnBox}>
                    <Button
                      className={styles.previewBtn}
                      type="primary"
                      key={index}
                      onClick={() => {
                        setFileViewerKey(index + Math.random());
                        setFileViewerPath(list);
                        setFileViewerType(
                          list.split('.')[list.split('.').length - 1]
                        );
                      }}
                    >
                      附件{index + 1}點擊顯示
                    </Button>
                    <a
                      className={styles.download}
                      download={list}
                      target="_blank"
                      href={list}
                    >
                      {list === '' ? '' : '下載'}
                    </a>
                    {/* <Button
                          type="primary"
                          className={styles.download}
                          disabled={fetching}
                          onClick={() => {
                            download(list, list)
                            Message.success("檔案存放到下載目錄")
                          }}
                        >
                          {list === "" ? "" : "下載"}
                        </Button> */}
                  </div>
                );
              })}
            </div>
            {fileViewerType.split('.')[fileViewerType.split('.').length - 1] ===
            'pdf' ? (
              <React.Suspense fallback={<div>Loading...</div>}>
                <div key={fileViewerKey} className={styles.documentBlock}>
                  <Document
                    file={fileViewerPath}
                    options={{ workerSrc: '/pdf.worker.js' }}
                    onLoadSuccess={onDocumentLoadSuccess}
                  >
                    {Array.from(new Array(numPages), (el, index) => (
                      <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                    ))}
                  </Document>
                </div>
              </React.Suspense>
            ) : (
              <React.Suspense fallback={<div>Loading...</div>}>
                <div key={fileViewerKey} className={styles.fileViewerBlock}>
                  <FileViewer
                    filePath={fileViewerPath}
                    fileType={fileViewerType}
                    onError={onError}
                  />
                </div>
              </React.Suspense>
            )}
          </div>
        ) : (
          ruleFiles.map((list, index) => {
            return (
              <div className={styles.previewFileContainer}>
                {list === '' ? (
                  <h1>{list === '' ? '沒有檔案' : ''}</h1>
                ) : (
                  <a
                    className={styles.download}
                    download={list}
                    target="_blank"
                    href={list}
                  >
                    {list[0] === '' ? '' : '下載'}
                  </a>
                )}
                {/* <Button
                        type="primary"
                        className={styles.download}
                        disabled={fetching}
                        onClick={() => {
                          download(list, list)
                          Message.success("檔案存放到下載目錄")
                        }}
                      >
                        {list === "" ? "" : "下載"}
                      </Button> */}

                {list.split('.')[list.split('.').length - 1] === 'pdf' ? (
                  <React.Suspense fallback={<div>Loading...</div>}>
                    <div key={index} className={styles.documentBlock}>
                      <Document
                        file={list}
                        options={{ workerSrc: '/pdf.worker.js' }}
                        onLoadSuccess={onDocumentLoadSuccess}
                      >
                        {Array.from(new Array(numPages), (el, index) => (
                          <Page
                            key={`page_${index + 1}`}
                            pageNumber={index + 1}
                          />
                        ))}
                      </Document>
                    </div>
                  </React.Suspense>
                ) : (
                  <React.Suspense fallback={<div>Loading...</div>}>
                    <div key={index} className={styles.fileViewerBlock}>
                      <FileViewer
                        filePath={list}
                        fileType={list.split('.')[list.split('.').length - 1]}
                        onError={onError}
                      />
                    </div>
                  </React.Suspense>
                )}
              </div>
            );
          })
        )}
      </Modal>

      <Button
        onClick={() => {
          setAddDeviceDialog(true);
        }}
      >
        新增設備
      </Button>

      <Button
        className={styles.findBtn}
        type="primary"
        onClick={() => {
          setSerachDialog(true);
        }}
      >
        查詢設備
      </Button>
      <Button
        className={styles.findBtn}
        type="primary"
        onClick={() => {
          serverDataUpdate();
        }}
      >
        重置搜尋
      </Button>
      <br />
      <br />

      {/* 查詢公告 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={serachDialog}
        onOk={() => {
          if (!serachCategory && !serachKey) {
            Message.warning('至少選擇一種(以上)方式搜尋');
          }

          if (serachCategory && serachKey) {
            const serach = deviceArr.filter(
              (x) =>
                x.deviceName.match(
                  serachKey.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\@\.]/g, '')
                ) && x.deviceVendor[0].name === serachCategory
            );

            setDeviceArr(serach);
            setSerachDialog(false);
          } else if (serachCategory) {
            const serach = deviceArr.filter(
              (x) => x.deviceVendor[0].name === serachCategory
            );
            setDeviceArr(serach);
            setSerachDialog(false);
          } else if (serachKey) {
            const serach = deviceArr.filter((x) =>
              x.deviceName.match(
                serachKey.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\@\.]/g, '')
              )
            );
            setDeviceArr(serach);
            setSerachDialog(false);
          }
          setSerachCategory('');
          setSerachKey('');
        }}
        onCancel={() => {
          setSerachDialog(false);
        }}
        onClose={() => {
          setSerachDialog(false);
        }}
      >
        <Form>
          <h2>設備搜尋</h2>
          <Item label="設備廠商">
            <Select
              style={{ width: '100%' }}
              hasClear
              placeholder="請選擇廠商"
              dataSource={communityVendorResult()}
              onChange={(value) => {
                setSerachCategory(value);
              }}
            />
          </Item>
          <Item label="關鍵字(設備名稱搜尋)">
            <Input
              name="keyWord"
              placeholder="請輸入關鍵字"
              onChange={(value) => {
                // console.log('onChange', value);
                setSerachKey(value);
              }}
            />
          </Item>
        </Form>
      </Dialog>

      {/* 新增設備 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={addDeviceDialog}
        onOk={() => {
          if (!editingObj.deviceName && !ruleType && !rule) {
            Message.warning('請確實填寫資料');
          } else if (!editingObj.deviceName) {
            Message.warning('請填寫設備名稱');
          } else {
            Swal.fire({
              title: `確定新增(${
                editingObj.deviceName ? editingObj.deviceName : ''
              })設備?`,
              text: '請確認資料填寫完整!!',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#BEBEBE',
              confirmButtonText: '確定',
              cancelButtonText: '取消',
            }).then((result) => {
              if (result.isConfirmed) {
                // funCreate({
                //   createdTime: new Date().toLocaleString(),
                //   updatedTime: new Date().toLocaleString(),
                //   // deviceName: deviceName,
                //   // deviceVendor: deviceVendor,
                //   rule: todo,
                //   ...editingObj
                // })

                createCommunityDeviceWithImgUploads()
                  .then((res) => {
                    Swal.fire(
                      '成功!',
                      `設備(${
                        editingObj.deviceName ? editingObj.deviceName : ''
                      })已新增`,
                      'success'
                    );
                    console.log('==communityDevice create success:', res);

                    serverDataUpdate();
                    setRule('');
                    setRuleType('');
                    setFiles('');
                    setFilesType('');
                    setTodo([]);
                    setDocument([]);
                    setDeviceVendor([]);
                    setEditingObj({});
                    setFile('');
                    setParsed64('');
                    setAddDeviceDialog(false);
                  })
                  .catch((error) => {
                    console.log('==communityDevice create fail:', error);
                    // Message.error(`${err}`);
                  });
              }
            });
          }
        }}
        onCancel={() => {
          setRule('');
          setRuleType('');
          setFiles('');
          setFilesType('');
          setDocument([]);
          setDeviceVendor([]);
          setTodo([]);
          setEditingObj({});
          setFile('');
          setParsed64('');
          setAddDeviceDialog(false);
        }}
        onClose={() => {
          setRule('');
          setRuleType('');
          setFiles('');
          setFilesType('');
          setDocument([]);
          setDeviceVendor([]);
          setTodo([]);
          setEditingObj({});
          setFile('');
          setParsed64('');
          setAddDeviceDialog(false);
        }}
      >
        <Form>
          <h3>新增設備</h3>
          <Item label="設備名稱">
            <Input
              name="deviceName"
              placeholder="請輸入設備名稱"
              maxLength={25}
              hasLimitHint
              aria-label="input max length 25"
              onChange={(value) => {
                // setDeviceName(value);
                const obj = { deviceName: value };
                setEditingObj({ ...editingObj, ...obj });
              }}
            />
          </Item>
          <Item label="設備編號">
            <Input
              name="deviceNumber"
              placeholder="請輸入設備編號"
              maxLength={25}
              hasLimitHint
              aria-label="input max length 25"
              onChange={(value) => {
                const obj = { deviceNumber: value };
                setEditingObj({ ...editingObj, ...obj });
              }}
            />
          </Item>
          <Item label="保管人">
            <Input
              name="deviceKeeper"
              placeholder="請輸入保管人"
              maxLength={25}
              hasLimitHint
              aria-label="input max length 25"
              onChange={(value) => {
                setEditingObj({ ...editingObj, deviceKeeper: value });
              }}
            />
          </Item>
          <Item label="保管位置">
            <Input
              name="deviceStorePlace"
              placeholder="請輸入保管位置"
              maxLength={25}
              hasLimitHint
              aria-label="input max length 25"
              onChange={(value) => {
                setEditingObj({ ...editingObj, deviceStorePlace: value });
              }}
            />
          </Item>
          <Item label="設備廠商">
            <Select
              hasClear
              className={styles.options2}
              placeholder="請選擇設備廠商"
              dataSource={communityVendorResult()}
              onChange={(value) => {
                getVendor(value);
              }}
            />
          </Item>
          <Item label="購入日期">
            <DatePicker
              // disabledDate={disabledDate}
              hasClear={false}
              placeholder="選擇日期"
              value={
                editingObj.hasOwnProperty('deviceDate')
                  ? moment(parseInt(editingObj.deviceDate)).format('YYYY-MM-DD')
                  : ''
              }
              onChange={(value) => {
                const obj = { deviceDate: moment(value).valueOf() };
                setEditingObj({ ...editingObj, ...obj });
              }}
            />
          </Item>
          <Item label="備註">
            <Input
              name="deviceNote"
              placeholder="請輸入備註"
              maxLength={150}
              hasLimitHint
              aria-label="input max length 150"
              onChange={(value) => {
                const obj = { deviceNote: value };
                setEditingObj({ ...editingObj, ...obj });
              }}
            />
          </Item>

          <Form.Item label="上傳設備照片">
            <input
              accept="image/png, image/jpeg"
              ref={uploadFile}
              onChange={handleFiles}
              type="file"
              id="file"
              name="files"
              // multiple
            />
          </Form.Item>
          {/* <img style={{ width: "50px", height: "50px" }} src={`${parsed64.length > 0 ? parsed64 : ezconImg}`} alt="圖片"></img> */}
          <Image
            className={styles.photo}
            src={`${parsed64.length > 0 ? parsed64 : ezconImg}`}
            alt="圖片"
          />
          <Item label="類別及規範">
            <div className={styles.optionBox}>
              <Select
                hasClear
                className={styles.options}
                placeholder="請選擇規範類別"
                value={ruleType}
                dataSource={communityRulesType()}
                onChange={(value) => {
                  //  console.log(value)
                  if (!value) {
                    setRule('');
                  }
                  setRule('');
                  setRuleType(value);
                }}
              />
              <Select
                disabled={!ruleType}
                hasClear
                className={styles.options}
                placeholder="請先選擇規範類別"
                value={rule}
                dataSource={communityRulesResult()}
                onChange={(value) => {
                  //  console.log(value)
                  setRule(value);
                }}
              />
              <Button
                type="secondary"
                className={styles.ruleBtn}
                onClick={addRules}
              >
                新增規範
              </Button>
            </div>
            <div className={styles.ruleContainer}>
              {todo.map((todo) => (
                <div key={todo.id} className={styles.ruleBox}>
                  <div>
                    類別:{todo.ruleType}-標題{todo.rule}
                  </div>
                  <Button
                    type="normal"
                    className={styles.delBtn}
                    warning
                    onClick={() => deleteTodo(todo.id)}
                  >
                    刪除
                  </Button>
                </div>
              ))}
            </div>
          </Item>
          <Item label="上傳附件">
            <div className={styles.optionBox}>
              <Select
                hasClear
                className={styles.options}
                placeholder="請選擇檔案類別"
                value={filesType}
                dataSource={communityFileType()}
                onChange={(value) => {
                  //  console.log(value)
                  if (!value) {
                    setFiles('');
                  }
                  setFiles('');
                  setFilesType(value);
                }}
              />
              <Select
                disabled={!filesType}
                hasClear
                className={styles.options}
                placeholder="請先選擇文件類別"
                value={files}
                dataSource={communityFilesResult()}
                onChange={(value) => {
                  //  console.log(value)

                  setFiles(value);
                  getFiles(value);
                }}
              />

              <Button
                type="secondary"
                className={styles.ruleBtn}
                onClick={() => {
                  setFilesType('');
                  setFiles('');
                  setDocument([]);
                }}
              >
                清除
              </Button>
            </div>
            <br />
            {document.length > 0
              ? document.map((list, index) => {
                  return (
                    <div key={index}>
                      {list.files.map((item, index) => {
                        return (
                          <a
                            key={index}
                            className={styles.download}
                            download={item}
                            target="_blank"
                            href={item}
                          >
                            {item[0] === '' ? '' : `附件${index + 1}`}
                          </a>
                        );
                      })}
                    </div>
                  );
                })
              : null}
          </Item>

          {/* <Item label="規範">
            <CascaderSelect
              className={styles.options}
              multiple
              placeholder="請選擇規範"
              dataSource={communityRulesOption()}
        
              onChange={(value, data, extra) => {
              
                // console.log("extra", extra.checkedData)

                if (extra.checkedData.length && extra.checkedData.length > 0) {

                  const checkedData = extra.checkedData.filter((x) => { return !x.children });
               
                  // console.log("checkedData", checkedData)
                  let obj = {};
                  checkedData.forEach((i) => {
                    let arr = {};
                    arr.type = i.value.split('-' + i.label)[0];
                    arr.title = i.label;
                    obj[i.id] = arr;
                  })
                  // console.log("obj",obj)
                  setRule(obj)
                }

              }}
            ></CascaderSelect>
          </Item> */}
        </Form>
      </Dialog>

      {/* 編輯設備 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={editDeviceDialog}
        onOk={() => {
          if (!editingObj.deviceName && !editingObj.deviceVendor) {
            Message.warning('請確實填寫資料');
          } else if (!editingObj.deviceName) {
            Message.warning('請填寫設備名稱');
          } else if (!editingObj.deviceVendor) {
            Message.warning('請填寫設備廠商');
          } else {
            Swal.fire({
              title: `確定修改(${editingObj.deviceName})設備?`,
              text: '請確認修改資料!!',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#BEBEBE',
              confirmButtonText: '確定',
              cancelButtonText: '取消',
            }).then((result) => {
              if (result.isConfirmed) {
                const data = currentPosts[editDeviceIndex];
                // let newObj = { ...data, updatedTime: new Date().toLocaleString(), deviceName: deviceName, deviceVendor: deviceVendor, rule: todo, }

                const newObj = {
                  ...data,
                  ...editingObj,
                  updatedTime: new Date().toLocaleString(),
                  rule: todo,
                  document,
                  deviceVendor,
                };
                // if(todo.length>0){//此次修改有變更 rule
                //   Object.assign(newObj, {rule: todo} );
                // }
                // funUpdate(data._id, newObj)

                patchCommunityDeviceWithImgUploads(newObj)
                  .then((res) => {
                    Swal.fire({
                      position: 'center',
                      icon: 'success',
                      title: '編輯成功',
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    serverDataUpdate();
                    setRule('');
                    setRuleType('');
                    setTodo([]);
                    setFiles('');
                    setFilesType('');
                    setDocument([]);
                    setDeviceVendor([]);
                    setEditingObj({});
                    setFile('');
                    setParsed64('');
                    setVendorName('');
                    setEditDeviceDialog(false);
                  })
                  .catch((error) => {
                    console.log('==communityDevice update fail:', error);
                    Message.success('更新失敗');
                  });
              }
            });
          }
        }}
        onCancel={() => {
          setRule('');
          setRuleType('');
          setTodo([]);
          setFiles('');
          setFilesType('');
          setDocument([]);
          setDeviceVendor([]);
          setVendorName('');
          setFile('');
          setParsed64('');
          setEditDeviceDialog(false);
        }}
        onClose={() => {
          setRule('');
          setRuleType('');
          setTodo([]);
          setFiles('');
          setFilesType('');
          setDocument([]);
          setDeviceVendor([]);
          setVendorName('');
          setFile('');
          setParsed64('');
          setEditDeviceDialog(false);
        }}
      >
        <Form>
          <h3>編輯設備</h3>

          <Item label="設備名稱">
            <Input
              value={
                editingObj.hasOwnProperty('deviceName')
                  ? editingObj.deviceName
                  : ''
              }
              name="deviceName"
              placeholder="請輸入設備名稱"
              maxLength={25}
              hasLimitHint
              aria-label="input max length 25"
              onChange={(value) => {
                // setDeviceName(value);
                const obj = { deviceName: value };
                setEditingObj({ ...editingObj, ...obj });
              }}
            />
          </Item>
          <Item label="設備編號">
            <Input
              value={
                editingObj.hasOwnProperty('deviceNumber')
                  ? editingObj.deviceNumber
                  : ''
              }
              name="deviceNumber"
              placeholder="請輸入設備編號"
              maxLength={25}
              hasLimitHint
              aria-label="input max length 25"
              onChange={(value) => {
                const obj = { deviceNumber: value };
                setEditingObj({ ...editingObj, ...obj });
              }}
            />
          </Item>
          <Item label="保管人">
            <Input
              name="deviceKeeper"
              defaultValue={
                Object.hasOwn(editingObj, 'deviceKeeper')
                  ? editingObj.deviceKeeper
                  : ''
              }
              placeholder="請輸入保管人"
              maxLength={25}
              hasLimitHint
              aria-label="input max length 25"
              onChange={(value) => {
                setEditingObj({ ...editingObj, deviceKeeper: value });
              }}
            />
          </Item>
          <Item label="保管位置">
            <Input
              name="deviceStorePlace"
              placeholder="請輸入保管位置"
              defaultValue={
                Object.hasOwn(editingObj, 'deviceStorePlace')
                  ? editingObj.deviceStorePlace
                  : ''
              }
              maxLength={25}
              hasLimitHint
              aria-label="input max length 25"
              onChange={(value) => {
                setEditingObj({ ...editingObj, deviceStorePlace: value });
              }}
            />
          </Item>
          <Item label="設備廠商">
            <Select
              hasClear
              className={styles.options2}
              placeholder="請選擇設備廠商"
              value={vendorName || ''}
              dataSource={communityVendorResult()}
              onChange={(value) => {
                getVendor(value);
                setVendorName(value);
              }}
            />
          </Item>
          <Item label="購入日期">
            <DatePicker
              // disabledDate={disabledDate}
              hasClear={false}
              placeholder="選擇日期"
              value={
                editingObj.hasOwnProperty('deviceDate')
                  ? moment(parseInt(editingObj.deviceDate)).format('YYYY-MM-DD')
                  : ''
              }
              onChange={(value) => {
                const obj = { deviceDate: moment(value).valueOf() };
                setEditingObj({ ...editingObj, ...obj });
              }}
            />
          </Item>
          <Item label="備註">
            <Input
              name="deviceNote"
              placeholder="請輸入備註"
              value={
                editingObj.hasOwnProperty('deviceNote')
                  ? editingObj.deviceNote
                  : ''
              }
              maxLength={150}
              hasLimitHint
              aria-label="input max length 150"
              onChange={(value) => {
                const obj = { deviceNote: value };
                setEditingObj({ ...editingObj, ...obj });
              }}
            />
          </Item>
          <Form.Item label="上傳設備照片">
            <input
              accept="image/png, image/jpeg"
              ref={uploadFile}
              onChange={handleFiles}
              type="file"
              id="file"
              name="files"
              // multiple
            />
          </Form.Item>
          {/* <img style={{ width: "50px", height: "50px" }} src={`${parsed64.length > 0 ? parsed64 : file}`} alt="圖片"></img> */}
          <Image
            className={styles.photo}
            src={`${parsed64.length > 0 ? parsed64 : file}`}
            alt="圖片"
          />
          <Item label="類別及規範">
            <div className={styles.optionBox}>
              <Select
                hasClear
                className={styles.options}
                placeholder="請選擇規範類別"
                value={ruleType}
                dataSource={communityRulesType()}
                onChange={(value) => {
                  //  console.log(value)
                  if (!value) {
                    setRule('');
                  }
                  setRule('');
                  setRuleType(value);
                }}
              />
              <Select
                disabled={!ruleType}
                hasClear
                className={styles.options}
                placeholder="請先選擇規範類別"
                value={rule}
                dataSource={communityRulesResult()}
                onChange={(value) => {
                  //  console.log(value)
                  setRule(value);
                }}
              />
              <Button
                type="secondary"
                className={styles.ruleBtn}
                onClick={addRules}
              >
                新增規範
              </Button>
            </div>
            <div className={styles.ruleContainer}>
              {todo.map((todo) => (
                <div key={todo.id} className={styles.ruleBox}>
                  <div>
                    類別:{todo.ruleType}-標題{todo.rule}
                  </div>
                  <Button
                    type="normal"
                    className={styles.delBtn}
                    warning
                    onClick={() => deleteTodo(todo.id)}
                  >
                    刪除
                  </Button>
                </div>
              ))}
            </div>
          </Item>
          <Item label="上傳附件">
            <div className={styles.optionBox}>
              <Select
                hasClear
                className={styles.options}
                placeholder="請選擇檔案類別"
                value={filesType}
                dataSource={communityFileType()}
                onChange={(value) => {
                  //  console.log(value)
                  if (!value) {
                    setFiles('');
                  }
                  setFiles('');
                  setFilesType(value);
                }}
              />
              <Select
                disabled={!filesType}
                hasClear
                className={styles.options}
                placeholder="請先選擇文件類別"
                value={files}
                dataSource={communityFilesResult()}
                onChange={(value) => {
                  //  console.log(value)

                  setFiles(value);
                  getFiles(value);
                }}
              />

              <Button
                type="secondary"
                className={styles.ruleBtn}
                onClick={() => {
                  setFilesType('');
                  setFiles('');
                  setDocument([]);
                }}
              >
                清除
              </Button>
            </div>
            <br />
            {document.length > 0
              ? document.map((list, index) => {
                  return (
                    <div key={index}>
                      {list.files.map((item, index) => {
                        return (
                          <a
                            key={index}
                            className={styles.download}
                            download={item}
                            target="_blank"
                            href={item}
                          >
                            {item[0] === '' ? '' : `附件${index + 1}`}
                          </a>
                        );
                      })}
                    </div>
                  );
                })
              : null}
          </Item>

          {/* <Item label="規範">
            <CascaderSelect
              className={styles.options}
              multiple
              placeholder="請選擇規範"
              dataSource={communityRulesOption()}
              // value={editRulesOption()}
              onChange={(value, data, extra) => {
                // console.log("extra", extra.checkedData)

                if (extra.checkedData.length && extra.checkedData.length > 0) {

                  const checkedData = extra.checkedData.filter((x) => { return !x.children });
                  // console.log("checkedData", checkedData)
                  let obj = {};
                  checkedData.forEach((i) => {
                    let arr = {};
                    arr.type = i.value.split('-' + i.label)[0];
                    arr.title = i.label;
                    obj[i.id] = arr;
                  })
                  // console.log("obj",obj)
                  setRule(obj)
                }

              }}
            ></CascaderSelect>
          </Item> */}
        </Form>
      </Dialog>

      <Card free>
        <Card.Content>
          <Table dataSource={currentPosts} onSort={onTableSort}>
            <Table.Column
              sortable
              title="建立時間"
              dataIndex="createdTime"
              width={150}
            />

            <Table.Column
              sortable
              title="設備名稱"
              dataIndex="deviceName"
              width={150}
            />
            <Table.Column
              sortable
              title="設備編號"
              dataIndex="deviceNumber"
              width={150}
            />
            <Table.Column
              sortable
              title="保管人"
              dataIndex="deviceKeeper"
              width={150}
            />
            <Table.Column
              sortable
              title="保管位置"
              dataIndex="deviceStorePlace"
              width={150}
            />
            <Table.Column
              sortable
              title="購入日期"
              dataIndex="deviceDate"
              width={150}
              cell={(value, index, record) => {
                return (
                  <>
                    {moment(parseInt(record.deviceDate)).format('YYYY-MM-DD')}
                  </>
                );
              }}
            />
            <Table.Column
              title="設備廠商"
              width={150}
              cell={(value, index, record) => {
                // console.log(record.rule)
                return (
                  <>
                    {record.deviceVendor && record.deviceVendor.length > 0
                      ? record.deviceVendor.map((list) => {
                          return <p key={list.id}>{list.name}</p>;
                        })
                      : ''}
                  </>
                );
              }}
            />
            <Table.Column
              sortable
              title="設備註解"
              dataIndex="deviceNote"
              width={150}
            />
            <Table.Column
              title="設備規範"
              width={300}
              cell={(value, index, record) => {
                // console.log(record.rule)
                return (
                  <>
                    {record.rule && record.rule.length > 0
                      ? record.rule.map((list) => {
                          return (
                            <div className={styles.rulesBox} key={list.id}>
                              <div className={styles.rules}>
                                {list.ruleType}/{list.rule}
                              </div>
                              <Button
                                className={styles.ruleBtn}
                                type="secondary"
                                onClick={() => {
                                  setRuleFiles(list.files);
                                  setPreviewSingleDialog(true);
                                }}
                              >
                                查看
                              </Button>
                            </div>
                          );
                        })
                      : ''}
                  </>
                );

                //= ====以下元Object寫法＝＝＝＝
                // let arr = [];
                // Object.entries(record.rule).forEach(entry => {
                //   const [key, value] = entry;
                //   arr.push(value)

                // })
                // return (
                //   arr && arr.length > 0 ? arr.map((item, index) => {
                //     return (
                //       <p key={index}>{item.type}/{item.title}</p>
                //     )
                //   }) : ""
                // )
              }}
            />
            <Table.Column
              title="文件"
              width={300}
              cell={(value, index, record) => {
                // console.log(record.rule)
                return (
                  <>
                    {record.document && record.document.length > 0
                      ? record.document.map((list) => {
                          return (
                            <div className={styles.rulesBox} key={list.id}>
                              <div className={styles.rules}>
                                {list.type}/{list.title}
                              </div>
                              <Button
                                className={styles.ruleBtn}
                                type="secondary"
                                onClick={() => {
                                  setRuleFiles(list.files);
                                  setPreviewSingleDialog(true);
                                }}
                              >
                                查看
                              </Button>
                            </div>
                          );
                        })
                      : ''}
                  </>
                );
              }}
            />

            <Table.Column
              title="設備圖片"
              width={150}
              cell={(record, index) => {
                return (
                  <>
                    {currentPosts[index].hasOwnProperty('files') &&
                    currentPosts[index].files.length > 0 ? (
                      <Image
                        className={styles.imageUrl}
                        src={currentPosts[index].files}
                        alt="圖片"
                      />
                    ) : (
                      '無圖片'
                    )}
                  </>
                );
              }}
            />

            <Table.Column
              title="操作"
              width={100}
              lock="right"
              cell={(value, index, record) => {
                // console.log('==op ', value, index, record);
                return (
                  <div className={styles.btn}>
                    <Button
                      type="normal"
                      onClick={() => {
                        // setDeviceName(currentPosts[index].deviceName);
                        // setDeviceVendor(currentPosts[index].deviceVendor);
                        setEditingObj({ ...currentPosts[index] });
                        setTodo(currentPosts[index].rule);
                        setDocument(currentPosts[index].document);
                        setDeviceVendor(currentPosts[index].deviceVendor);
                        if (
                          currentPosts[index].hasOwnProperty('deviceVendor') &&
                          currentPosts[index].deviceVendor.length > 0
                        ) {
                          setVendorName(
                            currentPosts[index].deviceVendor[0].name
                          );
                        }
                        setDeviceIndex(index);
                        setEditDeviceDialog(true);
                        setFile(currentPosts[index].files);
                      }}
                    >
                      編輯
                    </Button>

                    <Button
                      type="primary"
                      warning
                      onClick={() => {
                        const item = currentPosts[index];
                        Swal.fire({
                          title: `確定刪除(${record.deviceName})設備?`,
                          text: '刪除後將無法復原!!',
                          icon: 'warning',
                          showCancelButton: true,
                          confirmButtonColor: '#3085d6',
                          cancelButtonColor: '#BEBEBE',
                          confirmButtonText: '確定',
                          cancelButtonText: '取消',
                        }).then((result) => {
                          if (result.isConfirmed) {
                            Swal.fire('刪除!', '此設備已刪除', 'success');
                            funRemove(item._id).then(() => {
                              // removeItem();
                              const prePages =
                                currentPage - 1 >= 0 ? currentPage - 1 : 0;
                              if (
                                deviceArr.length - 1 <=
                                prePages * postsPerPage
                              ) {
                                setCurrentPage(
                                  currentPage - 1 < 1 ? 1 : currentPage - 1
                                );
                              }
                              serverDataUpdate();
                            });
                          }
                        });
                      }}
                    >
                      刪除
                    </Button>
                  </div>
                );
              }}
            />
          </Table>

          <Pagination
            className={styles.pagination}
            total={deviceArr.length}
            pageSize={postsPerPage}
            totalRender={(total) => `Total: ${total}`}
            onChange={(pageNumber) => {
              setCurrentPage(pageNumber);
            }}
          />
        </Card.Content>
      </Card>
    </>
  );
};

export default DeviceList;
